export default "__VITE_ASSET__UueIqzPZ__ 720w";